import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/features/layout/AppShell.tsx");
